import React, { Component } from 'react'
import { checkTranslation } from '../utils/useful'
import { nanoid } from 'nanoid'
import { ReactComponent as Icon } from './open.svg';
import importedIcons from './inputs/icons';
// import styled from "styled-components";



export default class IntractionActionsList extends Component {
    state = {
        id: nanoid()
    }

    componentDidMount() {
        let ele = document.getElementsByTagName('stop');
        for (let i = 0; i < ele.length; i++) {

            if (ele[i].getAttribute('offset') == '1') {
                ele[i].setAttribute("stop-color", "gray");
            } else {
                ele[i].setAttribute("stop-color", "blue");
            }

        }
    }




    render() {
        return (
            <button id={this.state.id} className="flexcb w-100 hover-gray p-2 br-5" onClick={() => this.props?.onClick && this.props?.onClick(this.props.data.title, this.props.data)}>
                <div className='flexc'>
                    {this.props.data.icon ? (
                        // <Icon className='toolbar-icon flexcc'  width={18} height={18}/>

                        <img className='toolbar-icon flexcc' width={16} src={this.props.data.icon} />
                    ) :
                        this.props.data.check === true ?
                            // <Icon step-color='#ee5050' fill='#ee5050' />
                            <img className='toolbar-icon flexcc' width={16} src={importedIcons.check} />
                            :
                            <div style={{ width: '16px', height: '16px' }}></div>
                    }
                    <div>
                        <p className="font-size-12 mld-3 main-c3 text-start text-semibold" style={{ whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}>{checkTranslation(this.props.data.title)}</p>
                        {(this.props.description || this.props.data.des) && (
                            <p className="font-size-10 mld-3 main-c7 text-start" style={{ whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}>{checkTranslation(this.props.description ?? this.props.data.des)}</p>
                        )}
                    </div>
                </div>

                <div className='font-size-10 main-c8'>
                    <div>
                        {this.props.data.shortcut ?
                            <p className=' text-start' >{this.props.data.shortcut}</p>
                            :
                            this.props.data.sub == true ?
                                <img className='flexcc rtl-button' width={18} src={importedIcons.arrowRight} />
                                :
                                this.props.data.check2 == true ?
                                    <img className='flexcc' width={18} src={importedIcons.check} />
                                    :
                                    this.props.data.check3 == true ?
                                        <div className='flexcc' style={{ width: '18px', height: '18px' }}>
                                            <div style={{ width: '5px', height: '5px', borderRadius:100, backgroundColor:'#0075ff' }} />
                                        </div>
                                        :
                                        <div style={{ width: '18px', height: '18px' }}></div>
                        }
                    </div>
                </div>
            </button>
        )
    }
}



